import {
  dispatchSideMenuPopoverOpen,
  SIDE_MENU_POPOVER_ANCHOR_ATTRIBUTE,
} from 'components/shared/side-menu/side-menu-popover-events';

import type { NavItemBadgePopover } from 'components/shared/side-menu/nav-config';

export interface OpenSideMenuBadgePopoverOptions {
  anchorElement?: HTMLElement | null;
  fallbackAnchorElement?: HTMLElement | null;
  repositionOnly?: boolean;
  anchorGap?: number;
  onAutoOpened?: () => void;
}

export const getSideMenuPopoverAnchorElement = (
  sourceElement: HTMLElement
): HTMLElement | null => {
  const anchorElement = sourceElement.closest(
    `[${SIDE_MENU_POPOVER_ANCHOR_ATTRIBUTE}]`
  );

  return anchorElement instanceof HTMLElement ? anchorElement : null;
};

export const openSideMenuBadgePopover = (
  popover: NavItemBadgePopover | undefined,
  options: OpenSideMenuBadgePopoverOptions = {}
): void => {
  if (!popover) return;

  dispatchSideMenuPopoverOpen(popover, {
    anchorElement: options.anchorElement ?? undefined,
    fallbackAnchorElement: options.fallbackAnchorElement ?? undefined,
    repositionOnly: options.repositionOnly,
    anchorGap: options.anchorGap,
    onAutoOpened: options.onAutoOpened,
  });
};
